<template>
  <v-row>
    <v-col cols="12">
      <v-card-text>
        <v-row>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon v-bind="attrs" v-on="on" @click="refreshNotifications">
                <v-icon>mdi-refresh</v-icon>
              </v-btn>
            </template>
            <span>Refresh</span>
          </v-tooltip>
        </v-row>
        <template v-for="(notification, index) in notifications">
          <div :key="index">
            <v-list-item three-line>
              <v-list-item-content>
                <v-list-item-title>{{notification.title}}</v-list-item-title>
                <v-list-item-subtitle>{{notification.body}}</v-list-item-subtitle>
                <v-list-item-subtitle>{{ formatDatetime(notification.created_at) }}</v-list-item-subtitle>
                <v-list-item-subtitle>
                  <div v-if="notification.users != null && notification.users.length > 0">
                      Recipients:
                      <template v-for="(history, ind) in notification.users">
                        <span :key="ind" class="mr-1">
                          {{ history.user != null ? history.user.email : ''}}
                        </span>
                      </template>
                    </div>   
                    <div v-if="notification.users == null || notification.users.length <= 0">
                      No Users.
                    </div>   
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-divider v-if="notification.length - 1 !== index"></v-divider>
          </div>
        </template>
        <infinite-loading spinner="spiral" :identifier="notificationScrollOptions.id" @infinite="getNotifications" >
          <template v-slot:no-results>
            <div class="text-center"></div>
          </template>
        </infinite-loading>
      </v-card-text>
    </v-col>
  </v-row>
</template>

<script>
import { GET_NOTIFICATION_HISTORY } from "@/views/csr/store/typeDefs/notification";
import utilityMixin from "@/views/csr/mixins/utility";
export default {
  name: 'History',
  mixins: [utilityMixin],
  data() {
    return {
      notifications: [],
      notificationScrollOptions: {
        page: 1,
        id: +new Date(),
      },
    }
  },
  methods: {
    async refreshNotifications() {
      this.notifications = [];
      this.notificationScrollOptions = Object.assign(
        this.notificationScrollOptions,
        {
          page: 1,
          id: this.notificationScrollOptions.id + 1,
        }
      );
    },
    async getNotifications($state) {
      const payload = {
        page: this.notificationScrollOptions.page,
        type: "sent",
      };
      let gotNotifications = await this.$store.dispatch(
        GET_NOTIFICATION_HISTORY,
        payload
      );
      this.notifications = [...this.notifications, ...gotNotifications];
      if (gotNotifications.length === 15) {
        this.notificationScrollOptions.page += 1;
        $state.loaded();
      } else {
        $state.complete();
      }
    },
  }
}
</script>
